import { careTypeParagraphCopy } from "./shared"

const dementiaCareHomeIntroText = (locationName, totalCareHomeCount) =>
  totalCareHomeCount === 1
    ? `There is only 1 care home in ${locationName}`
    : `There are ${totalCareHomeCount} care homes in ${locationName}`

export default ({ locationName, regulatoryBody, dementiaCareHomeCount }) => [
  {
    question: `How many dementia care homes are there in ${locationName}?`,
    answer: `${dementiaCareHomeIntroText(locationName, dementiaCareHomeCount)} 
        offering specialist dementia care.`,
  },
  {
    question: `How are dementia care homes in ${locationName} regulated?`,
    answer: `${careTypeParagraphCopy(
      "dementia",
      locationName,
      regulatoryBody,
    )}`,
  },
]
